// Shared vocabulary for the database policy screens.
//
// The evaluator understands exactly these three policyFlow values. It folds
// case and also reads "deny" as block and "mfa" as mfa_required, but anything
// else it can't place is treated as "intent cannot be determined" and the login
// is REFUSED, with the policy named in the log — a typo denies rather than
// degrading to a default. That's why the form is a fixed-option select and
// never free text.
export const DB_POLICY_FLOWS = [
  {
    value: "mfa_required",
    label: "Require MFA",
    hint: "Sends a push to the IAM user; the session opens only on approval.",
    tone: "warn",
  },
  {
    value: "allow",
    label: "Allow",
    hint: "Opens the session with the listed privileges, no second factor.",
    tone: "success",
  },
  {
    value: "block",
    label: "Block",
    hint: "Refuses the login — no push is sent.",
    tone: "danger",
  },
];

export const DEFAULT_DB_POLICY_FLOW = "mfa_required";

// Maps a stored policyFlow onto the value the engine acts on. Blank or missing
// reads as Require MFA: that's what the backend fills in when the key is absent,
// so it's what an older policy without the field is actually doing. Returns
// null for anything the engine wouldn't recognise (which denies) so the UI can
// say so instead of inventing an action.
export function normalizeDbPolicyFlow(flow) {
  const v = String(flow ?? "").trim().toLowerCase();
  if (!v) return DEFAULT_DB_POLICY_FLOW;
  if (v === "mfa_required" || v === "mfa") return "mfa_required";
  if (v === "block" || v === "deny") return "block";
  if (v === "allow") return "allow";
  return null;
}

function flowMeta(flow) {
  const v = normalizeDbPolicyFlow(flow);
  return DB_POLICY_FLOWS.find((f) => f.value === v) || null;
}

export function dbPolicyFlowLabel(flow) {
  return flowMeta(flow)?.label || "Unrecognised";
}

export function dbPolicyFlowTone(flow) {
  return flowMeta(flow)?.tone || "neutral";
}

export const UNRECOGNISED_FLOW_NOTICE =
  "The engine doesn't recognise this action, so logins matching this policy are refused. Edit the policy and pick an action.";
